@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../packing-recommend/packing-applied.module.less';

.weight-field {
  display: flex;
  gap: @space-8;
  flex-flow: row wrap;
}

.scale-button {
  padding: @space-4 @space-12;
  gap: @space-8;

  color: var(--default--text-color--10);

  &:disabled {
    color: var(--default--text-color--14);
  }
}

.scale-icon {
  padding: 0;
  height: 20px;
  width: 20px;

  fill: var(--default--icon--fill-color--12);
}

.weight-input-outer-container {
  flex: 1;
  min-width: 190px;
}

.weight-input-inner-container {
  width: 100%;
  gap: @space-8;
}

.weight-input {
  flex: 1;
}

.number-input-container {
  width: 100%;
}

@import '../packing-recommend/packing-applied-classes.module.less';

.packing-applied-input {
  .packing-applied-input-styles();
}
